import DateEditor from './DateEditor.vue'
export default {
  install: function (Vue) {
    Vue.component('date-editor', DateEditor)
  }
}